import { render, staticRenderFns } from "./dataCenter.vue?vue&type=template&id=614170a8&scoped=true&"
import script from "./dataCenter.vue?vue&type=script&lang=js&"
export * from "./dataCenter.vue?vue&type=script&lang=js&"
import style0 from "./dataCenter.vue?vue&type=style&index=0&id=614170a8&scoped=true&lang=css&"
import style1 from "./dataCenter.vue?vue&type=style&index=1&id=614170a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614170a8",
  null
  
)

export default component.exports